import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "3",
      d: "m33.998 26-8 18a6 6 0 0 1-6-6v-8H8.678a4 4 0 0 1-4-4.6l2.76-18a4 4 0 0 1 4-3.4h22.56m0 22V4m0 22h5.34a4.62 4.62 0 0 0 4.66-4V8a4.62 4.62 0 0 0-4.66-4h-5.34"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M34 4v22h5.34A4.62 4.62 0 0 0 44 22V8a4.62 4.62 0 0 0-4.66-4z"
    }, null, -1)
  ])))
}
export default { render: render }